export const ETH_MAINNET = 1;
// Production
export const AVALANCHE = 43114;
export const ARBITRUM = 42161;
export const BOTANIX = 3637;
// Production source
export const SOURCE_BASE_MAINNET = 8453;
export const SOURCE_BSC_MAINNET = 56;
// Testnets
export const AVALANCHE_FUJI = 43113;
export const ARBITRUM_SEPOLIA = 421614;
// Testnet source
export const SOURCE_OPTIMISM_SEPOLIA = 11155420;
export const SOURCE_SEPOLIA = 11155111;
